export default __webpack_public_path__ + "static/media/new.76139692.svg";